module.exports = __webpack_public_path__ + "img/ljrz.d144558a.png";